import { useState } from "react";
import { BudgetItem, BudgetType, CurrentUser, FamilyFeatureValue, FamilyHasAccess } from "../../types";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import ModalFooterSaveCancel from "./ModalFooterSaveCancel";
import ModalHeader from "./ModalHeader";
import Toggle from "../Inputs/Toggle";
import { Features } from "../../constants";
import Dropdown from "../Inputs/Dropdown";

const EditBudgetOther = (props: any) => {
	let [budget, setBudget] = useState(props.Item as BudgetItem);
	let user: CurrentUser = useSelector((state: any) => state.userData.value);
	const hasIncomeFeature = FamilyHasAccess(user, Features.Income);

	return (<>
		<ModalHeader Title="Other Settings" Close={props.Close} />
		<div className="modal-body mt-5">
			<Grid container>
				<Toggle Size={12} Label="Require approval from unassigned users" OnChange={UpdateRequiresApproval} Checked={budget.requiresApproval} className="my-3" />
				<Toggle Size={12} Label={`Exclude items in this budget from ${FamilyFeatureValue(user, Features.TransactionTitle)} page`} OnChange={UpdateIsViewTransactions} Checked={!budget.isViewTransactions} className="my-3" />
				{hasIncomeFeature && (
					<Dropdown
						Size={12}
						Class="mb-0"
						Label="Budget Type"
						Options={[
							{ Id: BudgetType.Expense, Value: "Expense" },
							{ Id: BudgetType.Income, Value: "Income" },
							{ Id: BudgetType.Combined, Value: "Combined" },
						]}
						Index={0}
						Value={budget.budgetType ?? BudgetType.Expense}
						OnChange={UpdateBudgetType}
					/>
				)}
			</Grid>
		</div>
		<ModalFooterSaveCancel ShowSave={ShouldShowSave()} Save={() => props.OnSave(budget)} Close={props.Close} />
	</>);

	function ShouldShowSave() {
		if (!budget.description) return false;
		return true;
	}

	function UpdateRequiresApproval(event: any, newValue: boolean) {
		let item = ({ ...budget, requiresApproval: newValue });
		setBudget(item);
	}
	function UpdateIsViewTransactions(event: any, newValue: boolean) {
		let item = ({ ...budget, isViewTransactions: !newValue });
		setBudget(item);
	}
	function UpdateBudgetType(newValue: any) {
		const nextType = newValue as BudgetType;
		let variant = { ...budget.variant };
		if (nextType === BudgetType.Income) {
			if ((variant.incomeAmount ?? 0) === 0 && (variant.amount ?? 0) > 0) variant.incomeAmount = variant.amount;
			variant.amount = 0;
		} else if (nextType === BudgetType.Expense) {
			if ((variant.amount ?? 0) === 0 && (variant.incomeAmount ?? 0) > 0) variant.amount = variant.incomeAmount;
			variant.incomeAmount = 0;
		}
		setBudget({ ...budget, budgetType: nextType, variant });
	}
}

export default EditBudgetOther;